import { cn } from "@discovery/classnames";
import * as M from "@discovery/prelude/lib/data/maybe";
import { useHistory, useCallback, useMemo, } from "@discovery/common-dplus/lib/hooks";
import * as styles from "./styles.css";
export var LinkKind;
(function (LinkKind) {
    LinkKind[LinkKind["internal"] = 0] = "internal";
    LinkKind[LinkKind["eventListenerOnly"] = 1] = "eventListenerOnly";
    LinkKind[LinkKind["external"] = 2] = "external";
})(LinkKind || (LinkKind = {}));
const launchable = ["mailto", "tel"];
const isLaunchable = (link) => launchable.some((v) => link.startsWith(`${v}:`));
export const Link = ({ classNameM = M.empty(), children, href, kind, onClick, openInNewWindow = false, }) => {
    const [, { push }] = useHistory();
    const isSelf = useMemo(() => isLaunchable(href) || kind === LinkKind.internal, [kind, href]);
    const shouldOpenInNewWindow = openInNewWindow !== null && openInNewWindow !== void 0 ? openInNewWindow : kind === LinkKind.external;
    const rel = kind === LinkKind.external ? "noopener" : undefined;
    const target = useMemo(() => (shouldOpenInNewWindow ? "_blank" : undefined), [shouldOpenInNewWindow]);
    const navigate = useCallback(() => {
        if (kind !== LinkKind.eventListenerOnly) {
            if (shouldOpenInNewWindow) {
                open(href, target);
            }
            else if (isSelf) {
                push(href);
            }
            else {
                push(href);
            }
        }
    }, [isSelf, push, kind, href, shouldOpenInNewWindow, target]);
    const handleClick = useCallback((event) => {
        onClick && onClick();
        window.scrollTo(0, 0);
        if ((!event.ctrlKey && // on Windows & Unix: open in new tab, on Mac: opens the context menu, we don't even get the click
            !event.metaKey && // on Mac (⌘): open in new tab, on Windows (⊞): ??, on Unix: nothing?
            event.button === 0) ||
            kind === LinkKind.internal) {
            event.preventDefault();
            navigate();
        }
    }, [onClick, navigate, kind]);
    return (React.createElement("a", { className: cn(styles.href, classNameM), href: href, onClick: handleClick, target: target, rel: rel }, children));
};

